import "./Pricing.module.css";
import Header from "@/reusable_sections/Header";
import EmpowermentFramework from "./sections/EmpowermentFramework";
import AgencyVsInHouse from "./sections/AgencyVsInHouse";
import JoinTheResistance from "./sections/JoinTheResistance";
import FooterInfo from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Header />
      <EmpowermentFramework />
      <AgencyVsInHouse />
      <JoinTheResistance />
      <FooterInfo />
    </div>;
}